<template>
  <div>
    <ak-field label="Template Title" required>
      <ak-input ref="title" v-model="localTemplate.title" required />
    </ak-field>

    <ak-sms-form-select
      ref="from"
      v-model="localTemplate.from"
      :active-account="activeAccount"
      :active-agengy="activeAgency"
    />

    <ak-folder-form-select
      v-model="localTemplate.folder"
      :active-account="activeAccount"
      :active-agency="activeAgency"
    />
  </div>
</template>

<script>
import { ref, watch, defineComponent, onBeforeMount } from 'vue'
import FolderFormSelect from '../folders/FolderFormSelect.vue'
import SMSFormSelect from './SMSFormSelect.vue'
import Field from '@akerolabs/akero-vue/src/components/field/Field.vue'
import Input from '@akerolabs/akero-vue/src/components/input/Input.vue'

export default defineComponent({
  /**
   * @type {String}
   * @description This is the name of the component this will also
   * be the tag name of the component to use in templates
   * @example
   * <ak-sms-details-form></ak-sms-details-form>
   */
  name: 'AkSmsDetailsForm',

  /**
   * @type {Object}
   * @description A collection of components that this component
   * is dependant on.
   */
  components: {
    [FolderFormSelect.name]: FolderFormSelect,
    [SMSFormSelect.name]: SMSFormSelect,
    [Field.name]: Field,
    [Input.name]: Input,
  },

  /**
   * @type {Boolean}
   * @description This prevents all element attributes that are not
   * defined in the props object from being applied to the rendered
   * component root element, the exception to this is "class" all
   * of the given classes would be merged with the component
   * defined ones.
   */
  inheritAttrs: false,

  /**
   * @type {Object}
   * @description A collection of properties that may be passed into
   * the component these will be bound to the component instance and
   * may be access in the template and component methods.
   */
  props: {
    /**
     * @type {Object}
     * @description The active account (drilled in or users)
     */
    activeAccount: {
      default: () => ({}),
      type: Object,
    },

    /**
     * @type {Object}
     * @description The active agency (drilled in or users)
     */
    activeAgency: {
      default: () => ({}),
      type: Object,
    },

    /**
     * @type {Object}
     * @description The active template to be updated
     */
    template: {
      default: () => ({}),
      type: Object,
    },
  },

  emits: ['updateTemplate'],

  /**
   * @type {Function}
   * @returns {Object}
   * @description Returns the default state of the component.
   */
  setup(props, { emit }) {
    const title = ref(null)
    const from = ref(null)
    const localTemplate = ref({})

    /**
     * @description Runs the form validation
     */
    const validate = (force) => {
      return from.value.validate(force) && title.value.validate(force)
    }

    onBeforeMount(() => {
      localTemplate.value = props.template
    })

    watch(
      localTemplate,
      (val) => {
        emit('updateTemplate', val)
      },
      { deep: true },
    )

    return {
      title,
      from,
      localTemplate,
      validate,
    }
  },
})
</script>
